import React from "react";
import { graphql } from "gatsby";

import Seo from "../components/seo";
import MockupUI from "../components/modules/MockupUI";
import ImageUI from "../components/modules/ImageUI";
import ProductUI from "../components/modules/ProductUI";
import TiroirProduct from "../components/shop/TiroirProduct";

export const query = graphql`
  query ProductBySlug($slug: String!) {
    sanityProduct(slug: { current: { eq: $slug } }) {
      ...product
    }
  }
`;

const Product = ({ data }) => {
  // const { location } = useContext(WrapperContext);
  // const location = "http://localhost:8000/e-shop";

  const {
    seo,
    // title,
    // texte,
    images,
    mockup
    // price,
    // productVariations
  } = data.sanityProduct;
  // console.log(seo);
  return (
    <>
      {seo && (
        <Seo
          pageTitle={seo.metaTitle}
          pageDescription={
            seo.metaDescription ? seo.metaDescription : "product desc"
          }
          pageImage={seo.image.asset.url}
          template={`template-product`}
          page={true}
        />
      )}

      {/* <section className='section scrollY flex flex-row md:flex-col sm:scrollX '>
        {images.map((el, i) => (
          <ImageUI input={{ image: el }} key={i} />
        ))}
      </section>
      <ProductUI input={{ product: data.sanityProduct }} /> */}
      <TiroirProduct
        open={true}
        input={data.sanityProduct}
        card={
          <section className='section scrollY flex flex-row md:flex-col sm:scrollX '>
            {mockup
              ? images.map((image, j) => (
                  <MockupUI input={{ image: image }} key={j} />
                ))
              : images.map((image, j) => (
                  <ImageUI input={{ image: image }} key={j} />
                ))}
          </section>
        }
        content={
          <ProductUI input={{ product: data.sanityProduct }} />
        }></TiroirProduct>
    </>
  );
};

export default Product;
